/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mail_Compose_ConfirmInputs */

const en_mail_compose_confirm = /** @type {(inputs: Mail_Compose_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send email to ${i?.count} recipients?`)
};

const de_mail_compose_confirm = /** @type {(inputs: Mail_Compose_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-Mail an ${i?.count} Empfänger senden?`)
};

/**
* | output |
* | --- |
* | "Send email to {count} recipients?" |
*
* @param {Mail_Compose_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_confirm = /** @type {((inputs: Mail_Compose_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_confirm(inputs)
	return en_mail_compose_confirm(inputs)
});